import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { adminRoutes } from "./routes";
window.Vapor = require('laravel-vapor');
const router = createRouter({
    history: createWebHistory(),
    routes: adminRoutes
});
const app = createApp({});
app.use(router).mount('#app');
